import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { ToastService } from 'src/app/core/toast.service';
import { DeletePopupComponent } from 'src/app/modules/dashboard/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PostnewJob } from 'src/app/modules/profile/services/job-section.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables } from 'src/app/shared/enum/tables.enum';
@Component({
  selector: 'app-list-employee-type',
  templateUrl: './list-employee-type.component.html',
  styleUrls: ['./list-employee-type.component.scss']
})
export class ListEmployeeTypeComponent implements OnInit {
  displayedColumns: string[] = ['sNo', 'employee_type_name', 'created_at', 'updated_at', 'action'];
  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  totalElements: number = 0;
  offset = { value: 0 };
  limit = { value: 10 };
  employeeType: any[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private router: Router,
    private commonService:CommonServicesForAllModules,
    private route: ActivatedRoute, public feedService: FeedService, private toast: ToastService, private dialog: MatDialog, private jobService: PostnewJob) {
  }

  ngOnInit(): void {
    this.getEmployeeType();
    
  }

  ngAfterViewInit() {

  }
  
  editEmployeeType(employeeType: any) {
    
    if (employeeType.id) {
      this.router.navigate(['profile', 'list-employee-type-edit', 'edit', employeeType.id], {
        queryParams: { employeeTypeName: employeeType.employee_type_name }
      });
    }
  }

  getEmployeeType() {
    this.jobService.getEmployeeTypeList().subscribe(data => {
      if (Array.isArray(data)) {
        this.employeeType = [...data];
      } else {
        console.error("Expected an array but received:", data);
      }
    }, error => {
      console.error("Error fetching categories:", error);
      
    });
  }

  deleteEmployeeType(employeeType: any): void {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '600px',
      data: {
        item: employeeType,
        name: 'Employee Type',
      },
    });

    dialogRef.afterClosed().subscribe(async (response) => {
      if (response === 'yes' && employeeType?.id) {
        try {
          await this.commonService.DeleteById(Tables.Job_Types, employeeType.id);
          this.getEmployeeType();
          this.toast.openSnackBar('Employee Type deleted successfully');
        } catch (err) {
          console.error('Failed to delete Employee Type:', err);
          this.toast.openSnackBar('Failed to delete Employee Type');
        }
      }
    });
  }

  addEmployeeType(): void {
    this.router.navigate(['../add-employee-type'], { relativeTo: this.route });
  }
}